import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@lib-shared/material/material.module';

import { LayoutCoreSplashScreenComponent } from './components/layout-core-splashscreen/layout-core-splashscreen.component';
import { LayoutCoreComponent } from './components/layout-core/layout-core.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    LayoutCoreComponent,
    LayoutCoreSplashScreenComponent,
  ],
  exports: [LayoutCoreComponent, LayoutCoreSplashScreenComponent],
})
export class LayoutModule {}
